import React, { Component, PropTypes } from 'react';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import { connect } from 'react-redux';
import * as GlobalActions from '../../../../actions/global';
import * as ActionTypes from '../../../../constants/ActionTypes';

class LineStyles extends Component {
    render() {
        return (
            <div className="GlobalStyles">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-5">
                        <div className="row">
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Style"
                                    onChange={this.props.onBorderStyleChange(this.props.tagName)}
                                    defaultValue={this.props.style}
                                    values={this.props.availableBorderStyle.map(v => {
                                        return { key: v, label: v };
                                    })}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Width"
                                    onChange={this.props.onBorderWidthChange(this.props.tagName)}
                                    defaultValue={this.props.width}
                                    values={this.props.availableBorderWidth.map(v => {
                                        return { key: v, label: v };
                                    })}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <PresetColorPicker
                                    color={this.props.color}
                                    onColorChange={this.props.onFontColorChange(this.props.tagName)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-2"></div>
                    <div
                        className="col-xs-12 col-sm-4"
                        style={{ borderTop: this.props.width + ' ' + this.props.style + ' ' + this.props.color }}
                    ></div>
                </div>
            </div>
        );
    }
}

LineStyles.propTypes = {
    onBorderStyleChange: PropTypes.func,
    onBorderWidthChange: PropTypes.func,
    onFontColorChange: PropTypes.func,
    tagNameName: PropTypes.string,
    tagName: PropTypes.string,
    width: PropTypes.string,
    color: PropTypes.string,
    style: PropTypes.string,
    availableBorderWidth: PropTypes.array,
    availableBorderStyle: PropTypes.array
};

const mapStateToProps = state => {
    return { ...state.theme.global };
};

const mapDispatchToProps = dispatch => {
    return {
        onBorderStyleChange: tagName => {
            return event => dispatch(GlobalActions.setBorderStyle(tagName, event.target.value));
        },
        onBorderWidthChange: tagName => {
            return event => dispatch(GlobalActions.setBorderWidth(tagName, event.target.value));
        },
        onFontColorChange: tagName => {
            return event => dispatch(GlobalActions.setFontColor(tagName, event.target.value));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LineStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/global/LinesStyles.js